<template>
	<div class="dunk"  :class="{ 'active' : lower }">

		<transition name="clockfade">
			<div class="clock" v-if="lower">
				<div class="clock-body" :class="{ 'animate' : animateClock }">
					<div class="hand"></div>
				</div>
			</div>
		</transition>
		

		<img :src="require(`../assets/img/${startBeakerImg}`)" 
			class="beaker start-beaker"
			:class="{'show': !showEnd || (endBeakerImg===false && showEnd === true)}" key="startbeaker">

		<img :src="require(`../assets/img/${reactions[startMetalImg].endBeakerImg}`)"
		 	class="beaker end-beaker"
			:class="{'show' : showEnd === true && reactions[startMetalImg].endBeakerImg !== false, 'slow-trans' : slowTrans }" 
			key="endbeaker" 
			v-if="startMetalImg !== false && reactions[startMetalImg].endBeakerImg !== false">
	

		<div class="bubbles-contain">
						<transition name="fade"><img :src="require(`../assets/img/bubbles-s.gif`)" class="bubbles bubbles1" v-if="startMetalImg !== false && reactions[startMetalImg].bubbles >= 1 && showBubbles"></transition>
						<transition name="fade"><img :src="require(`../assets/img/bubbles-s.gif`)" class="bubbles bubbles2" v-if="startMetalImg !== false && reactions[startMetalImg].bubbles >= 2 && showBubbles"></transition>
						<transition name="fade"><img :src="require(`../assets/img/bubbles-s.gif`)" class="bubbles bubbles3" v-if="startMetalImg !== false && reactions[startMetalImg].bubbles >= 3 && showBubbles"></transition>
						<transition name="fade"><img :src="require(`../assets/img/bubbles-s.gif`)" class="bubbles bubbles4" v-if="startMetalImg !== false && reactions[startMetalImg].bubbles >= 4 && showBubbles" ></transition>
						<transition name="fade"><img :src="require(`../assets/img/bubbles-s.gif`)" class="bubbles bubbles5" v-if="startMetalImg !== false && reactions[startMetalImg].bubbles >= 5 && showBubbles"></transition>
		</div>

		<div class="metal-contain" :class="{ 'hold': lower }">

				<img :src="require(`../assets/img/${startMetalImg}.png`)"
					class="metal start-metal" 
					:class="{ 'show': !showEnd ||  reactions[startMetalImg].endMetalImg === false, 'slow-trans':slowTrans }" 
					v-if="startMetalImg !== false "
					key="startMetal">

				<img :src="require(`../assets/img/${reactions[startMetalImg].endMetalImg}`)" 
					class="metal end-metal" 
					:class="{ 'show': showEnd, 'slow-trans':slowTrans }" 
					v-if="startMetalImg !== false && reactions[startMetalImg].endMetalImg !== false"
					key="endMetal">

		</div>

		<div class="formula-contain" v-if="formula" :class="{'single' : single}">
			<p class="formula" v-html="formula"></p>
		</div>
	</div>
</template>


<script>
export default {
	name:"AcidDunk",
	props:{
		startBeakerImg: String,
		endBeakerImg:{
			type: [Boolean, String],
			default: false,
			required: false
		},		
		startMetalImg: {
			type: [Boolean, String],
			default: false,
			required: false
		},
		endMetalImg:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		formula:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		animate:{
			type: [Boolean, String],
			default: false,
			required: false
		},
		showEnd: {
			type: Boolean,
			default: false
		},
		lower: {
			type: Boolean,
			default: false
		},
		reactions:{
			type: [Boolean, Object],
			default: false
		},
		single:{
			type: Boolean,
			default: false
		},
		showBubbles:{
			type: Boolean,
			default: false
		},
		slowTrans: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			timer: 5,
			animateClock: false
		}
	},
	watch:{
		lower: function () {
			if(this.lower === true) {
				this.animateClock = true
			}else{
				this.animateClock = false
			}
		}
	},
}
</script>


<style lang="scss" scoped>

.dunk{
	position: relative;
	width: 100%;

	.beaker{
		opacity: 0;

		&.end-beaker{
			position: absolute;
			top: 0;
			left: 0;
			&.show { transition: opacity 3s; }
		}

		&.show{
			opacity: 1;
		}
	}

	&.active .beaker.show { opacity: 0.75; }


}

.clock{
	position: absolute;
	top: 1em;
	right: 2em;
	display: flex;
	align-items: center;

	.timer{
		font-size: 3em;
		color: $blue;

		.sm{
			font-size: .7em;
		}
	}

	.clock-body{
		height: 3em;
		width: 3em;
		border: solid 3px $green;
		border-radius: 10em;
		display: flex;
		justify-content: center;
		padding: 0.2em;
		
		&:before {
			display: block;
			content: '';
			position: absolute;
			width: 30%;
			height: 0.25em;
			background: $green;
			left: 35%;
			top: -0.35em;
			border-radius: 50%;
		}

		&.animate .hand {
			animation: clock linear 1s;
			animation-iteration-count: 10;
			transform-origin: 50% 100%;
			animation-fill-mode: forwards;
			animation-timing-function: linear;
		}
	}

	.hand{
		width: 0.2em;
		background: $green;
		height: 50%;
		border-radius: 1em;
	}
}

@keyframes clock {
	0%{
		transform: rotate(0deg);
	}

	100%{
		transform: rotate(360deg);
	}
}

.metal-contain{
	position: absolute;
	width: 100%;
	top: -50%;
	left: 0%;
	z-index: -1;
	display: flex;
	justify-content: center;
	transition: all 500ms;

	&.hold{
		top: 13%;
	}

	.metal{
		width: 10%;
		position: relative;

		opacity: 0;
		

		&.slow-trans{
			transition: opacity 5000ms;
		}

		&.show{
			opacity: 1;
		}

		&.end-metal{
			position: absolute;
			bottom: 0;
			z-index: 2;
		}
	}
}

.bubbles-contain {
	position: absolute;
	width: 100%;
	height: 100%;
	top: -35%;
	left: 0%;
	display: flex;
	justify-content: center;
	transition: all 500ms;	
	@media screen and (min-width: 500px) {	top: -30%; }
	@media screen and (min-width: 800px) {	top: -33%; }
	@media screen and (min-width: 1200px) {	top: -30%; }
}

.bubbles{
	position: absolute;
	bottom: -11px;
	z-index: 3;
	width: 10%;
	object-fit: cover;

	&.bubbles2{
		bottom: 0px;
		width: 8%;
		object-position: left;
	}
	&.bubbles3{
		bottom: -7px;
		width: 10%;
		object-position: right;
	}
	&.bubbles4{
		bottom: -8px;
		width: 11%;
		object-position: right;
	}
	&.bubbles5{
		bottom: -10px;
		width: 10%;
		object-position: right;
	}
}

.formula-contain{
	display: flex;
	justify-content: center;
	align-items: center;

	p{
		margin: 0;
		position: absolute;
		bottom: 15px;
	}

	&.single{
		p{
			font-size: 1.3rem;
			bottom: 15%;
		}
	}
}

.fade-enter-active, .fade-leave-active {
	transition: all 1000ms;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.fade-enter-active{
	position: absolute;
}

.clockfade-enter-active, .clockfade-leave-active {
	transition: all 500ms;
}
.clockfade-enter, .clockfade-leave-to {
	transform: translateX(3em);
	opacity: 0;
}
</style>